import React from 'react';
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-5 border-y border-border-light px-4 relative overflow-hidden" data-id="element-228">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-229"></div>

      <div className="max-w-4xl mx-auto flex flex-col sm:flex-row items-center justify-center gap-4 text-center relative z-10" data-id="element-230">
        <div className="flex items-center gap-2 text-2xl bg-white/5 px-4 py-2 rounded-full border border-white/10 shadow-inner" data-id="element-231">
          <span data-id="element-232">🇩🇪</span>
        </div>
        <p className="text-text-sec text-sm sm:text-base font-medium" data-id="element-233">
          Die Ressource Nr. 1 für über{' '}
          <span className="font-bold text-primary" data-id="element-234">12.000 Coaches</span> in ganz
          Europa.
        </p>
      </div>
    </section>;
}